import {
  GET_SESSION_TYPES,
  GET_SESSION_TYPES_FAIL,
  GET_SESSION_TYPES_SUCCESS,
  ADD_NEW_SESSION_TYPE,
  ADD_SESSION_TYPE_SUCCESS,
  ADD_SESSION_TYPE_FAIL,
  UPDATE_SESSION_TYPE,
  UPDATE_SESSION_TYPE_SUCCESS,
  UPDATE_SESSION_TYPE_FAIL,
  DELETE_SESSION_TYPE,
  DELETE_SESSION_TYPE_SUCCESS,
  DELETE_SESSION_TYPE_FAIL,
  
} from "./actionTypes";

export const getSessionTypes = () => ({
  type: GET_SESSION_TYPES,
})

export const getSessionTypesSuccess = (sessionTypes) => ({
  type: GET_SESSION_TYPES_SUCCESS,
  payload: sessionTypes,
})

export const getSessionTypesFail = error => ({
  type: GET_SESSION_TYPES_FAIL,
  payload: error,
})

export const addNewSessionType = (sessionType) => ({
  type: ADD_NEW_SESSION_TYPE,
  payload: sessionType,
})

export const addSessionTypeSuccess = (sessionType) => ({
  type: ADD_SESSION_TYPE_SUCCESS,
  payload: sessionType,
})

export const addSessionTypeFail = error => ({
  type: ADD_SESSION_TYPE_FAIL,
  payload: error,
})

export const updateSessionType = (sessionType) => ({
  type: UPDATE_SESSION_TYPE,
  payload: sessionType,
})

export const updateSessionTypeSuccess = (sessionType) => ({
  type: UPDATE_SESSION_TYPE_SUCCESS,
  payload: sessionType,
})

export const updateSessionTypeFail = error => ({
  type: UPDATE_SESSION_TYPE_FAIL,
  payload: error,
})

export const deleteSessionType = (sessionType) => ({
  type: DELETE_SESSION_TYPE,
  payload: sessionType,
})

export const deleteSessionTypeSuccess = (sessionType) => ({
  type: DELETE_SESSION_TYPE_SUCCESS,
  payload: sessionType,
})

export const deleteSessionTypeFail = error => ({
  type: DELETE_SESSION_TYPE_FAIL,
  payload: error,
})

export const resetSessionTypeActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});


